import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.site_feature_ */
export type SiteFeatureId = string & { __brand: 'SiteFeatureId' }

/** Represents the table public.site_feature_ */
export default interface SiteFeatureTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<SiteFeatureId, SiteFeatureId, SiteFeatureId>

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SiteFeature = Selectable<SiteFeatureTable>

export type SiteFeatureInitializer = Insertable<SiteFeatureTable>

export type SiteFeatureMutator = Updateable<SiteFeatureTable>

export const siteFeatureId = z.string() as unknown as z.Schema<SiteFeatureId>

export const siteFeature = z.object({
  id: siteFeatureId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SiteFeature>

export const siteFeatureInitializer = z.object({
  id: siteFeatureId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SiteFeatureInitializer>

export const siteFeatureMutator = z.object({
  id: siteFeatureId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SiteFeatureMutator>
